// Copyright (c) 2016 Deere & Company

import ClaimDetailsContainer from './claim-details-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    application: state.claims.track.application,
    claim: state.claims.track.claim,
    formValidation: state.claims.track.formValidation,
    installedBy: state.claims.track.installedBy,
    isEditable: state.claims.track.isEditable,
    isValidClaim: state.claims.track.isValidClaim,
    ownershipStatus: state.claims.ownershipStatus,
    product: state.claims.track.product,
    selectedAccounts: state.user.details.settings.dealer.accounts.selectedAccounts
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ClaimDetailsContainer);



// WEBPACK FOOTER //
// ./src/claim/track/components/claim-details-section/index.js